import { render } from "./rzrq.vue?vue&type=template&id=dde48ece&scoped=true&ts=true"
import script from "./rzrq.vue?vue&type=script&lang=ts"
export * from "./rzrq.vue?vue&type=script&lang=ts"

import "./rzrq.vue?vue&type=style&index=0&id=dde48ece&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde48ece"]])

export default __exports__